import { isValidLanguage } from '@repo/shared';
import { z } from 'zod';

export const createDescribeImageWithDatasetSchema = z.object({
  datasetId: z.string(),
  models: z.array(z.string()).min(1),
});

export type CreateDescribeImageWithDatasetSchema = z.infer<
  typeof createDescribeImageWithDatasetSchema
>;

export const createDescribeImageWithFileSchema = z.object({
  files: z.array(z.instanceof(File)),
  models: z.array(z.string()).min(1),
  languageCode: z.custom<string>(isValidLanguage),
  context: z.string().optional(),
});

export type CreateDescribeImageWithFileSchema = z.infer<
  typeof createDescribeImageWithFileSchema
>;
